import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconImageWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "16px",
	height: "14px",
	viewBox: "0 0 16 14",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: "Fill 2391"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("defs", {}),
		/* @__PURE__ */ _jsx("g", {
			id: "Library",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			transform: "translate(-221.000000, -1929.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "icons",
				transform: "translate(20.000000, 1829.000000)",
				fill: "#FFFFFF",
				children: /* @__PURE__ */ _jsx("g", {
					id: "image",
					transform: "translate(197.000000, 95.000000)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M6.542,9 C6.542,8.19666667 7.19533333,7.542 8,7.542 C8.80466667,7.542 9.45733333,8.19666667 9.45733333,9 C9.45733333,9.80333333 8.80466667,10.458 8,10.458 C7.19533333,10.458 6.542,9.80333333 6.542,9 L6.542,9 Z M18.6666667,12.7186667 L16.3153333,10.3333333 C16.3153333,10.3333333 15.6666667,9.66666667 15.0206667,9.66666667 C14.3746667,9.66666667 13.7473333,10.3333333 13.7473333,10.3333333 C13.7473333,10.3333333 11.9893333,12.3406667 11.3266667,13.0026667 C12.3953333,13.458 14.0133333,16.0926667 12.7773333,15.3066667 C11.5413333,14.5206667 9.37466667,13.6673333 9.37466667,13.6673333 L5.33333333,16.3333333 L5.33333333,6.33333333 L18.6666667,6.33333333 L18.6666667,12.7186667 Z M19.4166667,5 L4.58333333,5 C4.26066667,5 4,5.26133333 4,5.58333333 L4,17.75 C4,18.072 4.26066667,18.3333333 4.58333333,18.3333333 L19.4166667,18.3333333 C19.7386667,18.3333333 20,18.072 20,17.75 L20,5.58333333 C20,5.26133333 19.7386667,5 19.4166667,5 L19.4166667,5 Z",
						id: "Fill-2391"
					})
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgIconImageWhite);
export default ForwardRef;
